import { WorkflowBoard } from "../dtos";

/**
 * §Flow-closed-note: the one sentence the CRM says about a closed application — the header pill tooltip and the
 * above-the-tabs banner share it so the copy cannot drift (and it mirrors the WM case header word for word).
 * "Flow closed 8/9/2026, 2:05 PM at Credit Review - DBR & Payment Plan by Islam — DBR above the ceiling",
 * dropping the parts that are absent; a status rule's close (no actor, no step) reads "… automatically".
 */
export const closureSummary = (closure: NonNullable<WorkflowBoard["closure"]>): string => {
  const at = new Date(closure.at).toLocaleString();
  const step = closure.stepName?.trim() ? ` at ${closure.stepName.trim()}` : "";
  const by = closure.by?.trim() ? ` by ${closure.by.trim()}` : "";
  const how = step || by ? `${step}${by}` : " automatically";
  const reason = closure.reason?.trim() ? ` — ${closure.reason.trim()}` : "";
  return `Flow closed ${at}${how}${reason}`;
};
